export const FILENAME_EXTENSION_RE = /\.[a-zA-Z0-9]{1,10}$/;

const NUMBERED_SUFFIX_RE = /^(.*) \((\d+)\)$/;

export function findUniqueFilename(
    name: string,
    existingNames: string[]
): string {
    const existing = new Set(existingNames);
    if (!existing.has(name)) {
        return name;
    }

    const extMatch = name.match(FILENAME_EXTENSION_RE);
    const extension = extMatch ? extMatch[0] : "";
    const initialStem = extMatch ? name.slice(0, extMatch.index) : name;
    const suffixMatch = initialStem.match(NUMBERED_SUFFIX_RE);
    const baseStem = suffixMatch ? suffixMatch[1] : initialStem;

    for (let n = 1; n <= existing.size + 1; n++) {
        const candidate = `${baseStem} (${n})${extension}`;
        if (!existing.has(candidate)) {
            return candidate;
        }
    }
    return name;
}
